// This is a standin for the i18n library's $t and $tc methods we use in keap-web.
// It's not a full implementation, but allows us to use the same
// translation keys in core vue templates as we do in keap-web
// with minimal editing, in a single language, and (ideally) doesn't perpetuate
// the use of single file custom blocks (<i18n>)

import translations from '../i18n/en-us.json';
import get from 'lodash.get';

const $te = (path) => {
    const message = get(translations, path);

    if (!message) return false;

    return true;
}

const $t = (path, values) => {
    let message = get(translations, path);

    if (!message) return path;
    if (!values) return message;

    Object.keys(values).forEach((tag) => {
        const value = values[tag];

        message = message.replaceAll(`{${tag}}`, value);
    });

    return message;
}

const $tc = (path, count, values) => {
    const message = $t(path, values);

    if (message === path) return path;

    const parts = message
        .split('|')
        .map((part) => part.trim());

    if (count === 1 && parts.length > 2) return parts[1];
    if (count === 0 && parts.length > 2
        || count === 1 && parts.length > 1) return parts[0];

    return parts.at(-1);
}

export default {
    $t,
    $tc,
    $te,
};
